
// import React, { useEffect, useState } from 'react';
// import '../styles/OrgChart.css';
// import logo from '../assets/logowhite.png';

// const OrgChart = ({ userData }) => {

//   const [dynamicChart, setDynamicChart] = useState([]);

//   const isGenesis =
//     userData?.EmailId?.toLowerCase().includes("genesistech.co.in");
//   // Level 1 & 2: Executive Board
//   const executiveBoard = [
//     { name: "Shantaram Patil", role: "Director & CFO" },
//     { name: "Shubham Patil", role: "Director" },
//     { name: "Neeta Sangvikar", role: "Director" },
//     { name: "Ankur Patil", role: "Director" }
//   ];


//   const operationalDepts = [
//     {
//       head: "Shubham Patil (CTO)",
//       subGroups: [
//         { title: "IQPC & ETL", staff: ["Madhur Ingle (Tech PC)", "Suraj Kumar (Tech PC)","Rohit Varathe (Software Engineer)", "Abhishek Kulkarni (Tech PC)" , "Purva Jadhav (Tech PC)" , "Shivani Mundhrikar(Tech PC)" , "Priyal Dhawale(Tech PC)" ] },

//         { title: "GTE Software", staff: ["Nisha Kenchgali (Software Engineer )", "Gaurav Bavdhankar (Software Engineer )"] }
//       ]
//     },
//     {
//       head: "Neeta Sangvikar(Director)",
//       subGroups: [
//         { title: "Admin", staff: ["Kajal Patil  (Business Analyst)", "Sunita Patil (Admin)", "Ankush Patil (Office Boy)"] }
//       ]
//     },
//     {
//       head: "Vijayalakshmi S. ( Engineering Manager-BIM )",
//       subGroups: [
//         { title: "FSP LO", staff: ["Sushmita Chaudhari (BIM Modeler)", "Tanmay Gangurde (BIM Modeler)", "Prithviraj Gaikwad (BIM Modeler)", "Ganesh Chavan  (BIM Modeler)" ,"Dhanashri Kondke (BIM Modeler)" , "Aman Kumar (BIM Modeler)" , "Shreyash Dhulam (BIM Modeler)" , "Ajay Patil (BIM Modeler)" ] },
//         // { title: "FI IE", staff: ["Pankaj Gaikwad (BIM Modeler)", "Dhanashri Kondke (BIM Modeler)"] },
//         { title: "DDI", staff: ["Abhijt Shelar (BIM Modeler)", "Rakesh G.S (BIM Modeler)", "Priyanka Kale (BIM Modeler)"] },
//         { title: "DMS", staff: ["Arpit Milmile (BIM Modeler)", "Bhushan Patil (BIM Modeler)" , "Mahesh Akshay Komara (BIM Modeler)"] },
//         { title: "SP", staff: ["Rakesh Sharma (BIM Modeler)", "Rabia Khan (BIM Modeler)"] }
//       ]
//     },
//     {
//       head: "Ankur Patil (CEO) ",
//       subGroups: [
//         { title: "PC/Doc Control", staff: ["Riya Shah (Project Coordinator)"] },
//         { title: "Structural", staff: ["Akash Sonawane (Structural Engineer)", "Gudur Ather Ush Shams (Structural Engineer)"] },
//         { title: "Electrical", staff: ["Pratik Phad (TL Electrical)", "Shravani Pokale (Electrical Engineer)", "Sujin Prathap Singh S(Electrical Engineer)"] },
//         { title: "MeGA", staff: ["Niranjan Prasad (TL MeGA)", "Sanket Nandekar (Mechanical Engineer)", "Sashank Janga (Mechanical Engineer)", "Ambeshkumar Jha (Mechanical Engineer)", "Aekansh Rawat (Mechanical Engineer)", "Saurabh Pal (Mechanical Engineer)", "Shivi Sharma (Mechanical Engineer)", "Soham Lad (Mechanical Engineer)"] },
//         { title: "LTO", staff: ["Sarvesh Bhalerao ( Project Coordinator)", "Ehtesham Ali ( Project Coordinator)"] },
//       ]
//     }

//   ];

//   useEffect(() => {

//     if (isGenesis) return;

//     fetch(
//       "/gt-api/get_org_chart.php",
//       {
//         credentials: "include"
//       }
//     )
//       .then(res => res.json())
//       .then(data => {

//         if (data.success) {
//           setDynamicChart(data.records || []);
//         }

//       })
//       .catch(console.error);

//   }, [isGenesis]);

//   if (!isGenesis) {

//     const boardMembers =
//       dynamicChart.filter(x => x.section_type === "BOARD");

//     const ceo =
//       dynamicChart.find(x => x.section_type === "CEO");

//     const managers =
//       dynamicChart.filter(
//         x => x.section_type === "MANAGER"
//       );

//     return (

//       <div className="org-page-wrapper">

//         <div className="org-tree animate-in">

//           <ul>
//             <li>

//               <div className="node root-node glass board-directors-clean">
//                 BOARD OF DIRECTORS
//               </div>

//               <ul className="fade-in-delayed">

//                 {boardMembers.map(member => (

//                   <li key={member.id}>
//                     <div className="node member-node glass">

//                       <h3>{member.title}</h3>

//                       <span className="role-tag">
//                         {member.subtitle}
//                       </span>

//                     </div>
//                   </li>

//                 ))}

//               </ul>

//               <div className="hierarchy-separator"></div>

//               {ceo && (

//                 <ul className="fade-in-delayed-more">

//                   <li>

//                     <div className="node ceo-node glass center-ceo">

//                       <h3>{ceo.title}</h3>

//                       <h4>{ceo.subtitle}</h4>

//                     </div>

//                     <ul>

//                       {managers.map(manager => {

//                         const groups =
//                           dynamicChart.filter(
//                             x =>
//                               x.section_type === "GROUP" &&
//                               Number(x.parent_id) === Number(manager.id)
//                           );

//                         return (

//                           <li
//                             key={manager.id}
//                             className="staggered-item"
//                           >

//                             <div className="node dept-head glass">
//                               <div>{manager.title}</div>
//                               <small>{manager.subtitle}</small>
//                             </div>

//                             <ul>

//                               {groups.map(group => {

//                                 const staff =
//                                   dynamicChart.filter(
//                                     x =>
//                                       x.section_type === "STAFF" &&
//                                       Number(x.parent_id) === Number(group.id)
//                                   );

//                                 return (

//                                   <li key={group.id}>

//                                     <div className="node group-title">
//                                       {group.title}
//                                     </div>

//                                     <ul className="staff-column">

//                                       {staff.map(emp => (

//                                         <li
//                                           key={emp.id}
//                                           className="staff-node glass"
//                                         >
//                                           {emp.title}
//                                           {emp.subtitle &&
//                                             ` (${emp.subtitle})`}
//                                         </li>

//                                       ))}

//                                     </ul>

//                                   </li>

//                                 );

//                               })}

//                             </ul>

//                           </li>

//                         );

//                       })}

//                     </ul>

//                   </li>

//                 </ul>

//               )}

//             </li>
//           </ul>

//         </div>

//       </div>

//     );
//   }

//   return (
//     <div className="org-page-wrapper">
//       <div className="bg-glow"></div>

//       <div className="org-tree animate-in">
//         <ul>
//           <li>
//             {/* Node with only the glass effect and a custom capsule class */}
//             <div className="node root-node glass board-directors-clean">
//               BOARD OF DIRECTORS
//             </div>

//             {/* LEVEL 2: DIRECTORS ROW */}
//             <ul className="fade-in-delayed">
//               {executiveBoard.map((dir, index) => (
//                 <li key={index}>
//                   <div className="node member-node glass">
//                     <h3>{dir.name}</h3>
//                     <span className="role-tag">{dir.role}</span>
//                   </div>
//                 </li>
//               ))}
//             </ul>

//             <div className="hierarchy-separator"></div>

//             <ul className="fade-in-delayed-more">
//               <li>
//                 <div className="node ceo-node glass center-ceo">
//                   <h3>Ankur Patil</h3>
//                   <h4>CEO</h4>

//                 </div>


//                 <ul>
//                   {operationalDepts.map((dept, idx) => (
//                     <li key={idx} className="staggered-item">
//                       <div className="node dept-head glass">{dept.head}</div>


//                       <ul>
//                         {dept.subGroups.map((group, gIdx) => (
//                           <li key={gIdx}>
//                             <div className="node group-title">{group.title}</div>


//                             <ul className="staff-column">
//                               {group.staff.map((member, sIdx) => (
//                                 <li key={sIdx} className="staff-node glass">
//                                   {member}
//                                 </li>
//                               ))}
//                             </ul>
//                           </li>
//                         ))}
//                       </ul>
//                     </li>
//                   ))}
//                 </ul>
//               </li>
//             </ul>
//           </li>
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default OrgChart;















import React, { useEffect, useState } from 'react';
import '../styles/OrgChart.css';
import logo from '../assets/logowhite.png';

const OrgChart = ({ userData }) => {

  const [dynamicChart, setDynamicChart] = useState([]);

  const isGenesis =
    userData?.EmailId?.toLowerCase().includes("genesistech.co.in") ||
    userData?.EmailId?.toLowerCase().includes("gtecorpgroup.com") ||
    userData?.EmailId?.toLowerCase().includes("gtcorpgroup.com");
  // Level 1 & 2: Executive Board
  const executiveBoard = [
    { name: "Shantaram Patil", role: "Director & CFO" },
    { name: "Shubham Patil", role: "Director" },
    { name: "Neeta Sangvikar", role: "Director" },
    { name: "Ankur Patil", role: "Director" }
  ];


  const operationalDepts = [
    {
      head: "Shubham Patil (CTO)",
      subGroups: [
        { title: "IQPC & ETL", staff: ["Madhur Ingle (Tech PC)", "Suraj Kumar (Tech PC)","Rohit Varathe (Software Engineer)", "Abhishek Kulkarni (Tech PC)" , "Purva Jadhav (Tech PC)" , "Shivani Mundhrikar(Tech PC)" , "Priyal Dhawale(Tech PC)" ] },

        { title: "GTE Software", staff: ["Nisha Kenchgali (Software Engineer )", "Gaurav Bavdhankar (Software Engineer )"] }
      ]
    },
    {
      head: "Neeta Sangvikar(Director)",
      subGroups: [
        { title: "Admin", staff: ["Kajal Patil  (Business Analyst)", "Sunita Patil (Admin)", "Ankush Patil (Office Boy)"] }
      ]
    },
    {
      head: "Vijayalakshmi S. ( Engineering Manager-BIM )",
      subGroups: [
        { title: "FSP LO", staff: ["Sushmita Chaudhari (BIM Modeler)", "Tanmay Gangurde (BIM Modeler)", "Prithviraj Gaikwad (BIM Modeler)", "Ganesh Chavan  (BIM Modeler)" ,"Dhanashri Kondke (BIM Modeler)" , "Aman Kumar (BIM Modeler)" , "Shreyash Dhulam (BIM Modeler)" , "Ajay Patil (BIM Modeler)" ] },
        // { title: "FI IE", staff: ["Pankaj Gaikwad (BIM Modeler)", "Dhanashri Kondke (BIM Modeler)"] },
        { title: "DDI", staff: ["Abhijt Shelar (BIM Modeler)", "Rakesh G.S (BIM Modeler)", "Priyanka Kale (BIM Modeler)"] },
        { title: "DMS", staff: ["Arpit Milmile (BIM Modeler)", "Bhushan Patil (BIM Modeler)" , "Mahesh Akshay Komara (BIM Modeler)"] },
        { title: "SP", staff: ["Rakesh Sharma (BIM Modeler)", "Rabia Khan (BIM Modeler)"] }
      ]
    },
    {
      head: "Ankur Patil (CEO) ",
      subGroups: [
        { title: "PC/Doc Control", staff: ["Riya Shah (Project Coordinator)"] },
        { title: "Structural", staff: ["Akash Sonawane (Structural Engineer)", "Gudur Ather Ush Shams (Structural Engineer)"] },
        { title: "Electrical", staff: ["Pratik Phad (TL Electrical)", "Shravani Pokale (Electrical Engineer)", "Sujin Prathap Singh S(Electrical Engineer)"] },
        { title: "MeGA", staff: ["Niranjan Prasad (TL MeGA)", "Sanket Nandekar (Mechanical Engineer)", "Sashank Janga (Mechanical Engineer)", "Ambeshkumar Jha (Mechanical Engineer)", "Aekansh Rawat (Mechanical Engineer)", "Saurabh Pal (Mechanical Engineer)", "Shivi Sharma (Mechanical Engineer)", "Soham Lad (Mechanical Engineer)"] },
        { title: "LTO", staff: ["Sarvesh Bhalerao ( Project Coordinator)", "Ehtesham Ali ( Project Coordinator)"] },
      ]
    }

  ];

  useEffect(() => {

    if (isGenesis) return;

    fetch(
      "/gt-api/get_org_chart.php",
      {
        credentials: "include"
      }
    )
      .then(res => res.json())
      .then(data => {

        if (data.success) {
          setDynamicChart(data.records || []);
        }

      })
      .catch(console.error);

  }, [isGenesis]);

  if (!isGenesis) {

    const boardMembers =
      dynamicChart.filter(x => x.section_type === "BOARD");

    const ceo =
      dynamicChart.find(x => x.section_type === "CEO");

    const managers =
      dynamicChart.filter(
        x => x.section_type === "MANAGER"
      );

    return (

      <div className="org-page-wrapper">

        <div className="org-tree animate-in">

          <ul>
            <li>

              <div className="node root-node glass board-directors-clean">
                BOARD OF DIRECTORS
              </div>

              <ul className="fade-in-delayed">

                {boardMembers.map(member => (

                  <li key={member.id}>
                    <div className="node member-node glass">

                      <h3>{member.title}</h3>

                      <span className="role-tag">
                        {member.subtitle}
                      </span>

                    </div>
                  </li>

                ))}

              </ul>

              <div className="hierarchy-separator"></div>

              {ceo && (

                <ul className="fade-in-delayed-more">

                  <li>

                    <div className="node ceo-node glass center-ceo">

                      <h3>{ceo.title}</h3>

                      <h4>{ceo.subtitle}</h4>

                    </div>

                    <ul>

                      {managers.map(manager => {

                        const groups =
                          dynamicChart.filter(
                            x =>
                              x.section_type === "GROUP" &&
                              Number(x.parent_id) === Number(manager.id)
                          );

                        return (

                          <li
                            key={manager.id}
                            className="staggered-item"
                          >

                            <div className="node dept-head glass">
                              <div>{manager.title}</div>
                              <small>{manager.subtitle}</small>
                            </div>

                            <ul>

                              {groups.map(group => {

                                const staff =
                                  dynamicChart.filter(
                                    x =>
                                      x.section_type === "STAFF" &&
                                      Number(x.parent_id) === Number(group.id)
                                  );

                                return (

                                  <li key={group.id}>

                                    <div className="node group-title">
                                      {group.title}
                                    </div>

                                    <ul className="staff-column">

                                      {staff.map(emp => (

                                        <li
                                          key={emp.id}
                                          className="staff-node glass"
                                        >
                                          {emp.title}
                                          {emp.subtitle &&
                                            ` (${emp.subtitle})`}
                                        </li>

                                      ))}

                                    </ul>

                                  </li>

                                );

                              })}

                            </ul>

                          </li>

                        );

                      })}

                    </ul>

                  </li>

                </ul>

              )}

            </li>
          </ul>

        </div>

      </div>

    );
  }

  return (
    <div className="org-page-wrapper">
      <div className="bg-glow"></div>

      <div className="org-tree animate-in">
        <ul>
          <li>
            {/* Node with only the glass effect and a custom capsule class */}
            <div className="node root-node glass board-directors-clean">
              BOARD OF DIRECTORS
            </div>

            {/* LEVEL 2: DIRECTORS ROW */}
            <ul className="fade-in-delayed">
              {executiveBoard.map((dir, index) => (
                <li key={index}>
                  <div className="node member-node glass">
                    <h3>{dir.name}</h3>
                    <span className="role-tag">{dir.role}</span>
                  </div>
                </li>
              ))}
            </ul>

            <div className="hierarchy-separator"></div>

            <ul className="fade-in-delayed-more">
              <li>
                <div className="node ceo-node glass center-ceo">
                  <h3>Ankur Patil</h3>
                  <h4>CEO</h4>

                </div>


                <ul>
                  {operationalDepts.map((dept, idx) => (
                    <li key={idx} className="staggered-item">
                      <div className="node dept-head glass">{dept.head}</div>


                      <ul>
                        {dept.subGroups.map((group, gIdx) => (
                          <li key={gIdx}>
                            <div className="node group-title">{group.title}</div>


                            <ul className="staff-column">
                              {group.staff.map((member, sIdx) => (
                                <li key={sIdx} className="staff-node glass">
                                  {member}
                                </li>
                              ))}
                            </ul>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))}
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default OrgChart;





